import { useEffect, useState } from "react";
import { BadgeCheck, ArrowUpRight, X } from "lucide-react";

const URL_ISOCRED = "https://isocred.nirogyam.net/";

export function IsoCredAd() {
  const [show, setShow] = useState(false);
  const [closed, setClosed] = useState(false);
  useEffect(() => {
    if (closed) return undefined;
    let t;
    const cycle = (on) => { setShow(on); t = setTimeout(() => cycle(!on), on ? 11000 : 7000); };
    t = setTimeout(() => cycle(true), 2500);
    return () => clearTimeout(t);
  }, [closed]);
  if (closed) return null;
  return (
    <div className={`isocred-wrap ${show ? "isocred-in" : "isocred-out"}`} aria-hidden={!show} data-testid="isocred-ad">
      <a href={URL_ISOCRED} target="_blank" rel="noopener noreferrer" className="isocred-card group" data-testid="isocred-ad-link">
        <span className="isocred-blob isocred-b1" /><span className="isocred-blob isocred-b2" /><span className="isocred-blob isocred-b3" />
        <span className="isocred-orbit"><BadgeCheck className="h-6 w-6 text-white" /></span>
        <span className="relative min-w-0">
          <span className="block text-[11px] uppercase tracking-[0.25em] text-white/70">Running a lab?</span>
          <span className="block text-base sm:text-lg font-semibold text-white">Want to get accredited? <span className="isocred-shine">Try isoCred by Nirogyam</span></span>
          <span className="block text-xs text-white/75">NABL & ISO readiness, documentation and audits – guided end to end.</span>
        </span>
        <span className="relative ml-auto inline-flex items-center gap-1 rounded-full bg-white px-4 py-2 text-sm font-semibold text-[#2412B5] transition-transform group-hover:translate-x-1">Explore<ArrowUpRight className="h-4 w-4" /></span>
      </a>
      <button onClick={() => setClosed(true)} className="isocred-close" aria-label="Hide" data-testid="isocred-ad-close"><X className="h-3.5 w-3.5" /></button>
    </div>
  );
}
